import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import ArrowRightIcon from "../../../assets/icons/arrow_right-01.svg2";
import TickIcon from "../../../assets/icons/tick.svg2";
import MovableIcon from "../../../assets/icons/movable.svg2";
import AddCircleIcon from "../../../assets/icons/add_circle-01.svg2";
import BoomerangIcon from "../../../assets/icons/boomerang_element-01.svg2";
import Select from "react-select";
import MyBadge from "../MyBadge";
import HelpButton from "../../HelpContent/HelpButton";
import MySelect from "../MySelect";

export default function GroupMapping() {
  return (
    <div>
      <Row className="mb-5 mt-3 p-3 ">
        <div className="col-12 col-lg">
          <div className="ms-2">
            <span className="fs-4 fw-bold ">
              Mapping your fields to system fields
            </span>
            <span className="text-secondary ms-2">
              <HelpButton />
            </span>
          </div>
          <div className="text-secondary ms-2">
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
          </div>
        </div>
        <div className="col-12 col-lg-auto">
          <span className="fw-bold">
            <MyBadge count={6} />
          </span>
          <span className="fw-bold ms-2 fs-4">
            fields that still need mopping
          </span>
        </div>
      </Row>

      <Row className="p-3">
        <Col xs={4}>
          <div className="fw-bold ms-2 fs-4 d-flex ">Your fields:</div>
        </Col>
        <Col xs={8}>
          <div className="fw-bold ms-2 fs-4 d-flex">
            System fields to map to:
          </div>
        </Col>
      </Row>

      <Row className="mb-2 mt-2 p-3">
        <Col xs={3}>
          <div className="d-flex gap-3 align-items-center mt-2">
            <div className="flex-grow-1">
              <MySelect
                options={[
                  { value: "firstName", label: "First Name asd" },
                  { value: "lastName", label: "Last Name" },
                  { value: "address", label: "Address" },
                  { value: "phoneNumber", label: "Phone Number" },
                ]}
                placeholder="First Name"
              />
            </div>
          </div>
        </Col>
        <Col xs={1} className="text-center mt-2">
          <ArrowRightIcon className="text-purple me-2" width={40} />
        </Col>

        <Col xs={7}>
          <div className="d-flex align-items-center gap-3 mt-2">
            <div className="flex-grow-1">
              <MySelect
                options={[
                  {
                    value: "systemGgroup",
                    label: (
                      <div>
                        <BoomerangIcon className=" me-2" width={30} />
                        <span className="fw-bold me-2">Group:</span>
                        <span>Main List</span>
                      </div>
                    ),
                  },
                  { value: "lastName", label: "Last Name" },
                  { value: "address", label: "Address" },
                  { value: "phoneNumber", label: "Phone Number" },
                ]}
                placeholder={
                  <div>
                    <BoomerangIcon className=" me-2" width={30} />
                    <span className="fw-bold me-2">Group:</span>
                    <span>Main List</span>
                  </div>
                }
              />
            </div>
            <div className="flex-grow-1">
              <MySelect
                options={[
                  {
                    value: "systemFirstName",
                    label: (
                      <div>
                        <BoomerangIcon className=" me-2" width={30} />
                        <span className=" me-2">System First Name</span>
                      </div>
                    ),
                  },
                  { value: "systemlastName", label: " System Last Name" },
                  { value: "systemaddress", label: " System Address" },
                  { value: "systemphoneNumber", label: "System Phone Number" },
                ]}
                placeholder={
                  <div>
                    <BoomerangIcon className=" me-2" width={30} />

                    <span className=" me-2">System First Name</span>
                  </div>
                }
              />
            </div>
          </div>
        </Col>

        <Col xs={1} className="d-flex gap-3 mt-3">
          <div>
            <TickIcon className="text-purple ms-2 me-3" width={20} />
          </div>
          <div>
            <MovableIcon className="me-2 opacity-50" width={20} />
          </div>
        </Col>
        <hr className="mt-3 text-secondary" />
      </Row>
      <Row className="mb-2 mt-2 p-3">
        <Col xs={3}>
          <div className="d-flex gap-3 align-items-center mt-2">
            <div className="flex-grow-1">
              <MySelect
                options={[
                  { value: "firstName", label: "First Name" },
                  { value: "lastName", label: "Last Name" },
                  { value: "address", label: "Address" },
                  { value: "phoneNumber", label: "Phone Number" },
                ]}
                placeholder="First Name"
              />
            </div>
          </div>
        </Col>
        <Col xs={1} className="text-center mt-2">
          <ArrowRightIcon className=" me-2" width={40} />
        </Col>

        <Col xs={7}>
          <div className="d-flex align-items-center gap-3 mt-2">
            <div className="flex-grow-1">
              <MySelect
                options={[
                  {
                    value: "systemGgroup",
                    label: (
                      <div>
                        <BoomerangIcon
                          className=" me-2"
                          width={30}
                        />
                        <span className="fw-bold me-2">Group:</span>
                        <span>Main List</span>
                      </div>
                    ),
                  },
                  { value: "lastName", label: "Last Name" },
                  { value: "address", label: "Address" },
                  { value: "phoneNumber", label: "Phone Number" },
                ]}
                placeholder={
                  <div>
                    <BoomerangIcon className=" me-2" width={30} />
                    <span className="fw-bold me-2">Group:</span>
                    <span>Main List</span>
                  </div>
                }
              />
            </div>
            <div className="flex-grow-1">
              <MySelect
                options={[
                  {
                    value: "systemFirstName",
                    label: (
                      <div>
                        <BoomerangIcon
                          className=" me-2"
                          width={30}
                        />
                        <span className=" me-2">System First Name</span>
                      </div>
                    ),
                  },
                  { value: "systemlastName", label: " System Last Name" },
                  { value: "systemaddress", label: " System Address" },
                  { value: "systemphoneNumber", label: "System Phone Number" },
                ]}
                placeholder={
                  <div>
                    <BoomerangIcon className=" me-2" width={30} />

                    <span className=" me-2">System First Name</span>
                  </div>
                }
              />
            </div>
          </div>
        </Col>

        <Col xs={1} className="d-flex gap-3 mt-3">
          <div>
            <TickIcon className="text-purple ms-2 me-3" width={20} />
          </div>
          <div>
            <MovableIcon className="me-2 opacity-50" width={20} />
          </div>
        </Col>
        <hr className="mt-3 text-secondary" />
      </Row>
      <Row className="mb-2 mt-2 p-3">
        <Col xs={3}>
          <div className="d-flex gap-3 align-items-center mt-2">
            <div className="flex-grow-1">
              <MySelect
                options={[
                  { value: "firstName", label: "First Name" },
                  { value: "lastName", label: "Last Name" },
                  { value: "address", label: "Address" },
                  { value: "phoneNumber", label: "Phone Number" },
                ]}
                placeholder="First Name"
              />
            </div>
          </div>
        </Col>
        <Col xs={1} className="text-center mt-2">
          <ArrowRightIcon className="text-purple me-2" width={40} />
        </Col>

        <Col xs={7}>
          <div className="d-flex align-items-center gap-3 mt-2">
            <div className="flex-grow-1">
              <MySelect
                options={[
                  {
                    value: "systemGgroup",
                    label: (
                      <div>
                        <BoomerangIcon
                          className="me-2"
                          width={30}
                        />
                        <span className="fw-bold me-2">Group:</span>
                        <span>Main List</span>
                      </div>
                    ),
                  },
                  { value: "lastName", label: "Last Name" },
                  { value: "address", label: "Address" },
                  { value: "phoneNumber", label: "Phone Number" },
                ]}
                placeholder={
                  <div>
                    <BoomerangIcon className=" me-2" width={30} />
                    <span className="fw-bold me-2">Group:</span>
                    <span>Main List</span>
                  </div>
                }
              />
            </div>
            <div className="flex-grow-1">
              <MySelect
                options={[
                  {
                    value: "systemFirstName",
                    label: (
                      <div>
                        <BoomerangIcon
                          className=" me-2"
                          width={30}
                        />
                        <span className=" me-2">System First Name</span>
                      </div>
                    ),
                  },
                  { value: "systemlastName", label: " System Last Name" },
                  { value: "systemaddress", label: " System Address" },
                  { value: "systemphoneNumber", label: "System Phone Number" },
                ]}
                placeholder={
                  <div>
                    <BoomerangIcon className=" me-2" width={30} />

                    <span className=" me-2">System First Name</span>
                  </div>
                }
              />
            </div>
          </div>
        </Col>

        <Col xs={1} className="d-flex gap-3 align-items-center ">
          <div>
            <TickIcon className="text-purple ms-2 me-3" width={20} />
          </div>
          <div>
            <MovableIcon className="me-2 opacity-50" width={20} />
          </div>
        </Col>
        <hr className="mt-3 text-secondary" />
      </Row>
      <Row>
        <Col xs={6}></Col>
        <Col xs={6}>
          <div className="d-flex justify-content-end p-3">
            <Button
              type="submit"
              className="btn bg-white rounded-pill border-0 px-4"
            >
              <AddCircleIcon
                className="text-purple rounded-50 me-3"
                width={25}
              />
              <span className="text-black">Create new field</span>
            </Button>
          </div>
        </Col>
      </Row>
      <hr className="mt-3 text-secondary" />
    </div>
  );
}
